import { Route, Switch } from 'react-router-dom';
import ProtectedRoute from '../../utils/ProtectedRoute';
import { usePermissions } from '@/providers/Permissions.provider';
import BrandingSettingsPage from './Branding/BrandingSettingsPage';
import WebhooksPage from './Webhooks/WebhooksPage';
import isBrandingLocked from './isBrandingLocked.helper';

// Inner routes rendered in the shared Settings shell's content pane. The overview at /settings is
// rendered by the shell itself, so it has no route here.
export default function SettingsPageRoutes() {
  const { permissions } = usePermissions();

  return (
    <Switch>
      <ProtectedRoute
        isAllowed={!isBrandingLocked(permissions)}
        showPermission
        exact
        path="/settings/brand-settings"
        component={BrandingSettingsPage}
      />

      {/* The shared page picks its Manage/History tab from the URL. */}
      <Route exact path={['/settings/webhooks', '/settings/webhooks/history']} component={WebhooksPage} />
    </Switch>
  );
}
